<template>
    <div class="animated fadeIn">
        <transactions-filter v-model="request" />
        <b-card v-if="$auth.isPartner">
            <div class="row justify-content-center">
                <div class="col-md-2 col-sm-12">
                    <div class="callout callout-success">
                        <small class="text-muted">
                        Total
                        <br />Vendas no Período
                        </small>
                        <h4 class="h4">{{totalSales}}</h4>
                    </div>
                </div>
                <div class="col-md-2 col-sm-12">
                    <div class="callout callout-success">
                        <small class="text-muted">
                        Total
                        <br />Empresa
                        </small>
                        <h4 class="h4">{{totalSeller}}</h4>
                    </div>
                </div>
                <div class="col-md-2 col-sm-12">
                    <div class="callout callout-warning">
                        <small class="text-muted">
                        Total
                        <br />Adquirencia / Banco
                        </small>
                        <h4 class="h4">{{totalAcquirer}}</h4>
                    </div>
                </div>
                <!-- <div class="col-md-2 col-sm-12">
                    <div class="callout callout-warning">
                        <small class="text-muted">
                        Total
                        <br />Plataforma
                        </small>
                        <h4 class="h4">{{totalPlatform}}</h4>
                    </div>
                </div> -->
                <div class="col-md-2 col-sm-12">
                    <div class="callout callout-warning">
                        <small class="text-muted">
                        Total
                        <br />Representante
                        </small>
                        <h4 class="h4">{{totalSalesPerson}}</h4>
                    </div>
                </div>
                <div class="col-md-2 col-sm-12">
                    <div class="callout callout-success">
                        <small class="text-muted">
                        Total Líquido
                        <br />Transações
                        </small>
                        <h4 class="h4">{{totalPartner}}</h4>
                    </div>
                </div>
            </div>
        </b-card>
        <b-card v-if="$auth.isSeller || $auth.isSalesPerson">
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <div class="callout callout-success">
                  <small class="text-muted">
                  Total
                  <br />Vendas Bruto
                  </small>
                  <h4 class="h4">{{totalSales}}</h4>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="callout callout-success">
                  <small class="text-muted">
                  Total
                  <br />Vendas Líquido
                  </small>
                  <h4 class="h4">{{totalSeller}}</h4>
              </div>
            </div>
          </div>

        </b-card>
        <balance-summary v-if="$auth.isSeller || $auth.isSalesPerson" />
        <b-card>
            <c-table
                @onPageIndexChanged="onPageIndexChanged"
                @onExportToExcelClick="exportToExcel"
                :table-data="result"
                :loading="loading"
                :fields="fields"
                :striped="true"
                :export-enabled="true"
                :actionUri="actionUri"
            ></c-table>
        </b-card>
    </div>
</template>
<script>
import cTable from "../../components/base/Table.vue";
import transactionService from "../../services/Transactions/transactionService";
import TransactionsFilter from './TransactionsFilter.vue';
import reportPage from './reportPage';
import BalanceSummary from '../../components/balance/summary.vue';
import config from '../../config';
export default {
  name: "report-transactions",
  inheritAttrs: false,
  mixins: [reportPage],
  components: {    
    cTable,
    TransactionsFilter,
    BalanceSummary
  },
  data: function () {
    return {
      actionUri: 'reports/transaction',      
      summaryResult: this.getEmptySummaryResult()
    };
  },
  computed: {
    totalAcquirer(){
      return this.summaryResult.totalAcquirer.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    totalSales(){
      return this.summaryResult.totalSales.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    totalPartner(){
      return this.summaryResult.totalPartner.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    totalSalesPerson(){
      return this.summaryResult.totalSalesPerson.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    totalSeller(){
      return this.summaryResult.totalSeller.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    totalPlatform(){
      return this.summaryResult.totalPlatform.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
  },
  created() {
    this.bindTableColumns();    
    this.fetchData(1);
    this.fetchSummaryData();
  },
  methods: {
    bindTableColumns() {
      this.fields[1].label = 'Data';
      if(this.$auth.isPartner) {
        this.fields.splice(2, 0, { key: "acquirerEscrowDate", label: "Adquir. data receb.", sortable: false },);
        this.fields.push({ key: "nuPartnerFeeFormatted", label: "Taxa", sortable: false });
        this.fields.push({ key: "acquirerFeeAmount", label: "Valor Adquire.", sortable: false });
        this.fields.push({ key: "spreadAmount", label: "Spread", sortable: false });
        this.fields.push({ key: "salespersonAmount", label: "Valor Rep.", sortable: false });      
        this.fields.push({ key: 'transactionActions', label: ''});
      }
      if(this.$auth.isFinance) {
        this.fields.push({ key: "nuPartnerFeeFormatted", label: "Taxa", sortable: false });
        this.fields.push({ key: "acquirerFeeAmount", label: "Valor Adquire.", sortable: false });
        this.fields.push({ key: "salespersonAmount", label: "Valor Rep.", sortable: false });
        this.fields.push({ key: 'transactionActions', label: ''});
      }
      if((this.$auth.isSeller || this.$auth.isSalesPerson) && config.partnersConfiguration.reports.showTransactionDetailLink) {
        this.fields.push({ key: 'transactionActions', label: ''});
      }
    },    
    getEmptySummaryResult() {
      return {
        totalAcquirer: 0,
        totalSales: 0,
        totalPartner: 0,
        totalSalesPerson: 0,
        totalSeller: 0,
        totalPlatform: 0,
      };
    },
    fetchSummaryData() {
      const self = this;
      this.showLoading();
      transactionService
        .summary(
          this.getRequestParams()
        )
        .then(
          (response) => {
            if(this.$auth.userRole == 'Partner' || this.$auth.userRole == 'Finance') {
              self.summaryResult.totalPartner = response.data.totalPartner;
              self.summaryResult.totalSalesPerson = response.data.totalSalesPerson;
              self.summaryResult.totalAcquirer = response.data.totalAcquirer;
              self.summaryResult.totalPlatform = response.data.totalPlatform;
            }
            
            self.summaryResult.totalSales = response.data.totalSales;            
            self.summaryResult.totalSeller = response.data.totalSeller;
            
            self.hideLoading();
          },
          () => {
            self.summaryResult = self.getEmptySummaryResult();
            self.hideLoading();
          }
        );
      
    },
    fetchData(page) {      
      const self = this;
      this.showLoading();
      transactionService
        .findAll(
          this.getRequestParams(),
          page
        )
        .then(
          (response) => {
            if(response.status == 204) {
              self.result = self.getEmptyResult()
            }
            else {
              self.result.data = response.data.data
              let transaction = {}
              for(let i = 0; i <= self.result.data.length - 1; i++) {
                transaction = self.result.data[i]
                transaction.transactionId = transaction.id
                
                transaction.paymentMethodFormatted = `${transaction.paymentMethodTypeName} (${transaction.installmentCount}x) <img width="30px" src="${transaction.paymentMethodImage}" alt="${transaction.paymentMethodName}">`
                transaction.nuPartnerFeeFormatted = `${transaction.fee.toLocaleString('pt-BR', { style: 'decimal' })}% | ${transaction.feeAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`                                                              
                transaction.cardNumber = transaction.paymentMethodTypeId == 5 || transaction.paymentMethodTypeId == 6 ? '' : `${transaction.deviceInfoBin.substr(0, 4)} ****** ${transaction.deviceInfoHolder}`
              }
              self.result.pageIndex = page
              self.result.rowCount = response.data.total
              self.result.pageSize = 10
            }            
            self.hideLoading();
          },
          () => {
            self.result = self.getEmptyResult();
            self.hideLoading();
          }
        );
    },  
    exportToExcel(tableName) {
      const self = this;
      this.showLoading();
      transactionService.findAllExport(this.getRequestParams()).then(
        (response) => {
          window.open(response);
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      );      
    },
  },
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>